import React from 'react';
import { FormForm } from '../../../../../../components/Form/FormForm';
import { useForm } from '@nerdgeschoss/react-use-form-library';
import { FormTextField } from '../../../../../../components/Form/TextField/FormTextField';
import { updateEventScannerNames } from '../../../../../../model/event';
import { handleError } from '../../../../../../model/notification';
import { t } from '../../../../../../locales/translate';

interface Props {
  eventId: string;
  scannerNames?: string[];
  onClose: () => void;
}

export function ScannerNamesForm({ eventId, scannerNames, onClose }: Props): JSX.Element {
  const { fields, changes, valid, onSubmit, submissionStatus } = useForm<{ name?: string | null }>({
    model: {},
    onSubmit: async () => {
      if (changes.name) {
        await updateEventScannerNames(eventId, [...(scannerNames || []), changes.name]);
      }
      onClose();
    },
    onSubmitError: (error) => handleError(error),
    validations: {
      name: 'required',
    },
  });

  return (
    <FormForm onSubmit={onSubmit} canSubmit={valid} onClose={onClose} loading={submissionStatus === 'submitting'}>
      <FormTextField label={t.model.scanner._name} {...fields.name} />
    </FormForm>
  );
}
